import { buildApiUrl } from '../../../../shared_app/utils/buildApiUrl';
var ACTIVITY_STREAM_API = {
    studentActivity: buildApiUrl('/api/teachers/students/:studentId/activity_stream'),
    assignmentsActivity: buildApiUrl("/api/teachers/students/:studentId/assignments_stream"),
    postSeenCards: buildApiUrl('/api/teachers/students/:studentId/mark_seen'),
    groupsActivity: buildApiUrl('/api/teachers/groups/:groupId/activity_stream_report'),
};
export { ACTIVITY_STREAM_API };
